import React, { useState } from 'react';
import {
  TextField,
  Autocomplete,
  Typography,
  Box,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import BaseModal from './BaseModal';

const AbsDnjResModal = ({
  open,
  onClose,
  onSubmit,
  loading,
  reportType,
  availableRegions,
  availableBranches,
  trainingTypes,
  dispatch,
}) => {
  const [filters, setFilters] = useState({
    caseType: '',
    dateRange: {
      startDate: null,
      endDate: null,
    },
    regions: [],
  });

  const caseTypes = [
    { value: 'ABS', label: 'Absent' },
    { value: 'DNJ', label: 'Did Not Join' },
    { value: 'RES', label: 'Resigned' },
    { value: 'ALL', label: 'All Cases' },
  ];

  const handleCaseTypeChange = (event) => {
    setFilters((prev) => ({ ...prev, caseType: event.target.value }));
  };

  const handleDateChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      dateRange: {
        ...prev.dateRange,
        [field]: value,
      },
    }));
  };

  const handleRegionChange = (event, value) => {
    setFilters((prev) => ({ ...prev, regions: value }));
  };

  const handleSubmit = () => {
    const payload = {
      caseType: filters.caseType,
      startDate: filters.dateRange.startDate,
      endDate: filters.dateRange.endDate,
      regionIds: filters.regions.map((r) => r.id),
      regionNames: filters.regions.map((r) => r.label),
    };

    onSubmit(payload);
  };

  const handleClose = () => {
    setFilters({
      caseType: '',
      dateRange: {
        startDate: null,
        endDate: null,
      },
      regions: [],
    });
    onClose();
  };

  const isSubmitDisabled =
    !filters.caseType ||
    !filters.dateRange.startDate ||
    !filters.dateRange.endDate ||
    filters.regions.length === 0;

  return (
    <BaseModal
      open={open}
      onClose={handleClose}
      onSubmit={handleSubmit}
      loading={loading}
      reportType={reportType}
      submitDisabled={isSubmitDisabled}
    >
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" sx={{ mb: 2, color: 'text.primary', fontWeight: 600 }}>
          Select Filters
        </Typography>

        <Grid container spacing={3}>
          {/* Case Type */}
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
              Case Type *
            </Typography>
            <FormControl fullWidth size="small">
              <InputLabel>Select case type</InputLabel>
              <Select
                value={filters.caseType}
                onChange={handleCaseTypeChange}
                label="Select case type"
                sx={{
                  borderRadius: 1.5,
                }}
              >
                {caseTypes.map((type) => (
                  <MenuItem key={type.value} value={type.value}>
                    {type.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Date Range */}
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
              Start Date *
            </Typography>
            <TextField
              type="date"
              fullWidth
              size="small"
              value={filters.dateRange.startDate || ''}
              onChange={(e) => handleDateChange('startDate', e.target.value)}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 1.5,
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
              End Date *
            </Typography>
            <TextField
              type="date"
              fullWidth
              size="small"
              value={filters.dateRange.endDate || ''}
              onChange={(e) => handleDateChange('endDate', e.target.value)}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 1.5,
                },
              }}
            />
          </Grid>

          {/* Regions */}
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
              Regions *
            </Typography>
            <Autocomplete
              multiple
              options={availableRegions || []}
              getOptionLabel={(option) => option.label || ''}
              value={filters.regions}
              onChange={handleRegionChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select regions"
                  variant="outlined"
                  fullWidth
                  size="small"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 1.5,
                    },
                  }}
                />
              )}
            />
          </Grid>
        </Grid>
      </Box>
    </BaseModal>
  );
};

export default AbsDnjResModal;
